@if (!user?.IsDistributor) {
  <div class="discounts-element" [ngClass]="elemClass">
    @for (d of discountsList; track d) {
      <div class="discounts" [ngClass]="widths">
        <ui-button [active]="d.key === discount?.key" [block]="true" [short]="true" (click)="setDiscount(d)" [buttonStyle]="'secondary'">
          {{d.key}}
        </ui-button>
      </div>
    }
    <div class="discount-percentage" [ngClass]="widths">
      @if (discountsList.length) {
        <ui-input #discountPercentage [disabled]="discount === null" [hasError]="!discountErrors.isValid" [type]="'number'" [value]="percentage" [min]="1" [max]="100" (valueChange)="setPercentage($event)">
          <ui-input-addon post [disabled]="discount === null">%</ui-input-addon>
        </ui-input>
      }
    </div>
  </div>
}